import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { bibShape, shelfItemShape } from '@bibliocommons/bc-prop-types';
import BibScreenReaderDescription from '@bibliocommons/shared-bib-screen-reader-description';
import { CatalogueResultItemButton, CatalogueResultItemAlert } from '@bibliocommons/add-title';
import AddTitleContainer from '../../../../../containers/shared/AddTitle/AddTitleContainer';
import { Plus } from '@bibliocommons/base-icons';
import BaseUGCEditor from '../BaseUGCEditor';

import './SimilarTitlesUGCEditor.scss';

export class SimilarTitlesUGCEditor extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderAddOn', 'renderScreenReaderMessage', 'handleAdd');
  }

  renderScreenReaderMessage(item) {
    return (<FormattedMessage
      id="ada_label_add_similar_title_to_bib"
      values={{ similarTitle: <BibScreenReaderDescription bibBrief={item} />, relatedBibTitle: this.props.bib.getIn(['briefInfo', 'title']) }} />);
  }

  /*
  handleAddSuccess(data) {
    TODO: update once POST Request endpoint is working
  } */

  handleAdd(item) {
    // make api call
    return () => {
      const metadataId = this.props.bib.get('id');
      const similarTitleId = item.get('id');
      // TODO: pass in postSuccess method once endpoint is working
      this.props.similarTitlesActions.addSimilarTitle(metadataId, similarTitleId, () => null);
    };
  }

  renderAddOn(item) {
    // if item does not have same metadataId as current bib, render addOn view
    if (item.get('id') !== this.props.bib.get('id')) {
      // if item exist in similar titles list, render the added icon
      if (this.props.similarTitleBibs.keySeq().includes(item.get('id'))) {
        return (<CatalogueResultItemAlert label={(<FormattedMessage id="added_to_shelf" />)} />);
      }

      // else render the add button
      return (
        <CatalogueResultItemButton
          icon={(<Plus />)}
          label={(<FormattedMessage id="add_to_shelf" />)}
          item={item}
          screenReaderMessage={this.renderScreenReaderMessage(item)}
          handleClick={this.handleAdd(item)} />
      );
    }

    return null;
  }

  render() {
    const { bib, shelfItem, shelfActions, shelfTransactions, handleClose } = this.props;

    const renderHeader = () => (<h2><FormattedMessage id="add_similar_titles" /></h2>);

    return (
      <BaseUGCEditor
        bib={bib}
        className="cp-similar-title-ugc-editor"
        renderHeader={renderHeader}
        shelfItem={shelfItem}
        shelfTransactions={shelfTransactions}
        shelfActions={shelfActions} >
        <AddTitleContainer
          handleClose={handleClose}
          renderAddOn={this.renderAddOn}
          addRowClassNames={(item) => ({ 'current-bib' : item.get('id') === bib.get('id') })} />
      </BaseUGCEditor>
    );
  }
}

SimilarTitlesUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  shelfItem: shelfItemShape,
  handleClose: PropTypes.func.isRequired,
  similarTitleBibs: ImmutablePropTypes.map,
  similarTitlesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  similarTitlesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default SimilarTitlesUGCEditor;



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/SimilarTitlesUGCEditor/SimilarTitlesUGCEditor.jsx